import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import EditorialMarquee from "../components/site/EditorialMarquee";
import About from "../components/site/About";
import Courses from "../components/site/Courses";
import WhyChooseUs from "../components/site/WhyChooseUs";
import Features from "../components/site/Features";
import DemoClass from "../components/site/DemoClass";
import Handouts from "../components/site/Handouts";
import Gallery from "../components/site/Gallery";
import Faq from "../components/site/Faq";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";
import FloatingButtons from "../components/site/FloatingButtons";

export default function Landing() {
  return (
    <div className="bg-paper">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <About />
        <Courses />
        <WhyChooseUs />
        <Features />
        <DemoClass />
        <Handouts />
        <Gallery />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
